import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/user2/Desktop/MDM/UdmsClient/uss/src/app/(public)/enterprise-solutions/components/EnterpriseSolutionsInteractive.tsx");
